<template>
  <div id="app" :key="app_key" class="overflow-hidden_x">
    <UiLoading v-if="0 && (ui.loading || !ui.init)" class="overlay big" />
    <div class="frame-wrap" v-else>

      <div class="pb-6 overflow-hidden_x">
        <router-view :key="$route.path" class="flex-auto" />
      </div>

    </div>
    
    <!-- ui for all pages -->
    <!-- share popup -->
    <CpPopupShareItem :mark_ui_call="item_on_share"/>
    <!-- addfund popup -->
    <CpPopupAddFund :cfg="cfg_on_add_fund"/>

    <Notifications />
    <storeWatch/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
//import spaces from '@/spaces';
import storeWatch from './views/storeWatch.vue'
import bus from '@/bus.js'

export default {
  components: {
    storeWatch
  },
  data(){
    return {
      app_key: 0,

      item_on_share: {},
      cfg_on_add_fund: {},

      _bus_view: bus,
    }
  },
  computed: {
    wrongNetwork() {
      return this.config.chainId !== this.web3.injectedChainId;
    },
    showLogin() {
      return (
        (!this.web3.account && !this.web3.injectedLoaded) ||
        (!this.web3.account && !this.wrongNetwork)
      );
    },
    /*
    space() {
      try {
        return spaces[this.$route.params.key];
      } catch (e) {
        return {};
      }
    }
    */
  },
  watch: {
    '$store.state.app.lang'(){
      let v = this
      v.app_key += 1
    },
    '$store.state.web3.account'(val){
      this.uniCheckUserLogin()
      if(val){
        this.uniGetWalletBalance()
      }
      this.app_key += 1
    },
    '$store.state.user.local_user.address'(val){
      if(val){
        this.uniListMyLikedItems()
      }
    },
    '$route.path'(){
      document.querySelector('body').classList.remove('lock-scroll')
    },
  },
  methods: {
    ...mapActions([
      'init',
    ]),

    // 全局单例弹框
    showPopupShareItem(item){
      this.item_on_share = JSON.parse(JSON.stringify(item))
    },
    showPopupAddFund(cfg){
      this.cfg_on_add_fund = JSON.parse(JSON.stringify(cfg))
    },

    async getPriceEthUsd(){
      let v = this

      await fetch('https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=USD').then(function(res){
        res.json().then(function(res){
          if(res && res.binancecoin && res.binancecoin.usd){
            let num = res.binancecoin.usd
            v.$store.commit("setTokenPriceKey",{
              eth_on_usd: num
            });
          }
        })
      })

      await fetch('https://api.coingecko.com/api/v3/simple/price?ids=juggernaut&vs_currencies=USD').then(function(res){
        res.json().then(function(res){
          if(res && res['juggernaut'] && res['juggernaut'].usd){
            let num = res['juggernaut'].usd
            v.$store.commit("setTokenPriceKey",{
              axis_on_usd: num
            });
          }
        })
      })

      await fetch('https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=USD').then(function(res){
        res.json().then(function(res){
          if(res && res.tether && res.tether.usd){
            let num = res.tether.usd
            v.$store.commit("setTokenPriceKey",{
              usdt_on_usd: num
            });
          }
        })
      })

      await fetch('https://api.coingecko.com/api/v3/simple/price?ids=pancakeswap-token&vs_currencies=USD').then(function(res){
        res.json().then(function(res){
          if(res && res['pancakeswap-token'] && res['pancakeswap-token'].usd){
            let num = res['pancakeswap-token'].usd
            v.$store.commit("setTokenPriceKey",{
              cake_on_usd: num
            });
          }
        })
      })

    },

    reloadApp(){
      this.app_key += 1
      // this.$store.hotUpdate()
    },

    run(){
      let v = this
      console.log('app run()')
      v.init();
      v.getPriceEthUsd()
      v.uniGetWalletBalance()
      v.uniListMyLikedItems()
    },
  },
  created(){
    bus.appvue = this
  },
  mounted() {
    this.run()
  },
  
};
</script>
<style lang="scss">
  @import '~@/assets/css/style.scss';

  .frame-wrap{
    min-height: 100.1vh;
    position: relative;
    // padding-bottom: 35px;

    /deep/ .site-footer{
      position: absolute;
      bottom: 30px;
    }

  }
</style>
